import { isEventbriteTLD } from '../selectors/app';
import { isLoginInterstitialSplitTreatmentEnabled } from '../selectors/splitio';
import { CheckoutState } from '../state';
import { isEventbriteTLDInDevOrQAEnv } from '../utils/browser';
import { getExperimentValueToOverride } from '../utils/statsig';

export const isStatsigFreeTrialEnabledForInterstitialLogin = (
    state: CheckoutState,
): boolean => {
    return (
        (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv()) &&
        isLoginInterstitialSplitTreatmentEnabled(state)
    );
};

export const isStatsigFreeTrialEnabled = (state: CheckoutState) =>
    isStatsigFreeTrialEnabledForInterstitialLogin(state);

export const getExperimentValue = (
    state: CheckoutState,
    experimentName: string,
) => {
    const valueToOverride = getExperimentValueToOverride(state, experimentName);

    if (valueToOverride) {
        return valueToOverride;
    }
    return state.statsig?.experiments?.[experimentName]?.value;
};
